// @flow

// import {toast} from 'react-toastify'

import {get, post, put, del} from "../client"
import type {
  Shop,
  ShopItem,
  SearchItem,
  Media,
  ShopItemType,
  ThunkAction,
  Action,
  Dispatch,
} from "../types"

export const fetchShopItems = (babyToken: string): ThunkAction => {
  return (dispatch: Dispatch) => {
    return get(`/babies/${babyToken}/shop/items`).then((response) => {
      dispatch(setShop(response.data.shop))
      return dispatch(setShopItems(response.data))
    })
  }
}

export const setShop = (shop: Shop): Action => ({
  type: "SET_SHOP",
  shop,
})

export const updateShop = (
  babyToken: string,
  isClosed: boolean
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return put(`/babies/${babyToken}/shop`, {isClosed}).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const setShopItems = (shopItems: $ReadOnlyArray<ShopItem>): Action => ({
  type: "SET_SHOP_ITEMS",
  shopItems,
})

export const unselectShopItems = (): Action => ({
  type: "UNSELECT_SHOP_ITEMS",
})

export const setShopSearchItems = (
  searchItems: $ReadOnlyArray<SearchItem>
): Action => ({
  type: "SET_SHOP_SEARCH_ITEMS",
  searchItems,
})

export const generateShop = (babyToken: string): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return post(`/babies/${babyToken}/shop/generate`, null).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(setShopSearchItems(response.data.searchItems))
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const generateShopTips = (babyToken: string): ThunkAction => {
  return () => post(`/babies/${babyToken}/shop/generate-tips`, null)
}

const shopIsProcessing = (): Action => ({
  type: "SET_SHOP_PROCESSING",
  isProcessing: true,
})

const shopIsDoneProcessing = (): Action => ({
  type: "SET_SHOP_PROCESSING",
  isProcessing: false,
})

export const toggleSelectedSearchItem = (searchItemKey: string): Action => ({
  type: "TOGGLE_SHOP_SELECTED_SEARCH_ITEM",
  searchItemKey,
})

export const createShopItem = (
  babyToken: string,
  type: ShopItemType,
  babyListItemIds: $ReadOnlyArray<number>
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return post(`/babies/${babyToken}/shop`, {
      type,
      babyListItemIds,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(setShopSearchItems(response.data.searchItems))
      dispatch(clearSelectedSearchItems())
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const createShopProductItems = (
  babyToken: string,
  babyListItemId: number,
  shopProducts: ShopProduct[]
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return post(`/babies/${babyToken}/shop`, {
      shopProducts,
      babyListItemId,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(setShopSearchItems(response.data.searchItems))
      // dispatch(clearSelectedSearchItems())
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const updateShopItem = (
  babyToken: string,
  shopItemId: number,
  nameNl: string,
  descriptionNl: string,
  nameFr: string,
  descriptionFr: string,
  nameEn: string,
  descriptionEn: string,
  parts: number,
  isPublished: boolean,
  isSticky: boolean
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return put(`/babies/${babyToken}/shop/${shopItemId}`, {
      nameNl,
      descriptionNl,
      nameFr,
      descriptionFr,
      nameEn,
      descriptionEn,
      parts,
      isPublished,
      isSticky,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const toggleSelectedShopItem = (shopItemId: number): Action => ({
  type: "TOGGLE_SELECTED_SHOP_ITEM",
  shopItemId,
})

const clearSelectedSearchItems = (): Action => ({
  type: "CLEAR_SELECTED_SEARCH_ITEMS",
})

export const publishShopItems = (
  babyToken: string,
  shopItemIds: $ReadOnlyArray<number>
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return post(`/babies/${babyToken}/shop/publish`, {
      shopItemIds,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(unselectShopItems())
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const unpublishShopItems = (
  babyToken: string,
  shopItemIds: $ReadOnlyArray<number>
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return post(`/babies/${babyToken}/shop/unpublish`, {
      shopItemIds,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(unselectShopItems())
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const deleteShopItems = (
  babyToken: string,
  shopItemIds: $ReadOnlyArray<number>
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return del(`/babies/${babyToken}/shop/delete`, {
      shopItemIds,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(setShopSearchItems(response.data.searchItems))
      dispatch(unselectShopItems())
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const deleteShopItem = (
  babyToken: string,
  shopItemId: number
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return del(`/babies/${babyToken}/shop/${shopItemId}`).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(setShopSearchItems(response.data.searchItems))
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const getShopItemMedia = (
  babyToken: string,
  shopItemId: number
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return get(`/babies/${babyToken}/shop/${shopItemId}/media`).then(
      (response) => {
        const {shopItemMedia, babyMedia} = response.data
        dispatch(setShopItemMedia(shopItemMedia, babyMedia))
        dispatch(shopIsDoneProcessing())
      }
    )
  }
}

export const updateShopItemMedia = (
  babyToken: string,
  shopItemId: number,
  mediaIds: $ReadOnlyArray<number>
): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(shopIsProcessing())
    return post(`/babies/${babyToken}/shop/${shopItemId}/media`, {
      mediaIds,
    }).then((response) => {
      dispatch(setShop(response.data.shop))
      dispatch(setShopItems(response.data.shopItems))
      dispatch(shopIsDoneProcessing())
    })
  }
}

export const setShopItemMedia = (
  shopItemMedia: $ReadOnlyArray<Media>,
  babyMedia: $ReadOnlyArray<Media>
) => ({
  type: "SET_SHOP_ITEM_MEDIA",
  shopItemMedia,
  babyMedia,
})

export const clearShopItemMedia = () => ({
  type: "CLEAR_SHOP_ITEM_MEDIA",
})

export const selectAllShopItems = () => ({
  type: "SELECT_ALL_SHOP_ITEMS",
})
